// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"IB-z","expressButtonContainerWithPayPal":"JB-z","expressButton":"KB-z","or":"LB-z"};